import { AuthPageLayout } from "./auth-page-layout";
import { Button, Icons } from "@/components/ui";

const ERROR_MESSAGES: Record<string, string> = {
  oauth_failed:
    "Social login failed. Please try again or use email/password.",
  oauth_cancelled: "Social login was cancelled.",
  email_not_verified:
    "Please verify your email address before signing in.",
  session_expired: "Your session has expired. Please sign in again.",
  unknown: "An unexpected error occurred. Please try again.",
};

interface AuthErrorPageProps {
  /** Error code to display. Defaults to "oauth_failed". */
  errorCode?: string;
}

export function AuthErrorPage({
  errorCode = "oauth_failed",
}: AuthErrorPageProps) {
  const message =
    ERROR_MESSAGES[errorCode] ?? ERROR_MESSAGES["unknown"]!;

  return (
    <AuthPageLayout>
      <div
        className="flex flex-col items-center gap-5 text-center"
        data-testid="auth-error"
      >
        <div className="flex h-16 w-16 items-center justify-center rounded-full border border-glass-stroke bg-glass-fill">
          <Icons.AlertTriangle className="h-7 w-7 text-danger" />
        </div>

        <h2 className="text-2xl font-semibold text-primary">
          Something went wrong
        </h2>

        <p className="text-canvas-xl leading-normal text-secondary">
          {message}
        </p>

        <Button
          variant="secondary"
          size="lg"
          onClick={() => console.log("[workshop] Navigate to login")}
          className="w-full liquid-glass-distortion shadow-glass border-glass-stroke-light font-semibold text-accent"
          data-testid="error-login-link"
        >
          Back to sign in
        </Button>
      </div>
    </AuthPageLayout>
  );
}
